var _rect, _circle, _circle2, _path, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChip10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 38,
    fill: "url(#paint0_linear_1605_4098)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 34.5,
    stroke: "white",
    strokeWidth: 7,
    strokeMiterlimit: 2.16568,
    strokeDasharray: "15 10"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 25.5,
    fill: "black",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6348 44H31.9189V36.5645C31.9189 36.3594 31.9219 36.1074 31.9277 35.8086C31.9336 35.5039 31.9424 35.1934 31.9541 34.877C31.9658 34.5547 31.9775 34.2646 31.9893 34.0068C31.9248 34.083 31.793 34.2148 31.5938 34.4023C31.4004 34.584 31.2188 34.748 31.0488 34.8945L29.5723 36.0811L28.2627 34.4463L32.4023 31.1504H34.6348V44ZM47.1328 37.5752C47.1328 38.6123 47.0508 39.5381 46.8867 40.3525C46.7285 41.167 46.4707 41.8584 46.1133 42.4268C45.7617 42.9951 45.2988 43.4287 44.7246 43.7275C44.1504 44.0264 43.4531 44.1758 42.6328 44.1758C41.6016 44.1758 40.7549 43.915 40.0928 43.3936C39.4307 42.8662 38.9414 42.1104 38.625 41.126C38.3086 40.1357 38.1504 38.9521 38.1504 37.5752C38.1504 36.1865 38.2939 35 38.5811 34.0156C38.874 33.0254 39.3486 32.2666 40.0049 31.7393C40.6611 31.2119 41.5371 30.9482 42.6328 30.9482C43.6582 30.9482 44.502 31.2119 45.1641 31.7393C45.832 32.2607 46.3271 33.0166 46.6494 34.0068C46.9717 34.9912 47.1328 36.1807 47.1328 37.5752ZM40.8486 37.5752C40.8486 38.5537 40.9014 39.3711 41.0068 40.0273C41.1182 40.6777 41.3027 41.167 41.5605 41.4951C41.8184 41.8232 42.1758 41.9873 42.6328 41.9873C43.084 41.9873 43.4385 41.8262 43.6963 41.5039C43.96 41.1758 44.1475 40.6865 44.2588 40.0361C44.3701 39.3799 44.4258 38.5596 44.4258 37.5752C44.4258 36.5967 44.3701 35.7793 44.2588 35.123C44.1475 34.4668 43.96 33.9746 43.6963 33.6465C43.4385 33.3125 43.084 33.1455 42.6328 33.1455C42.1758 33.1455 41.8184 33.3125 41.5605 33.6465C41.3027 33.9746 41.1182 34.4668 41.0068 35.123C40.9014 35.7793 40.8486 36.5967 40.8486 37.5752Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 20,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1605_4098",
    x1: 38,
    y1: 0,
    x2: 38,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.324689,
    stopColor: "#CB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC4E1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip10);
export default __webpack_public_path__ + "static/media/chip10.ace7b9fad8efe358c390159cc06f73dc.svg";
export { ForwardRef as ReactComponent };